import { createTheme as createMuiTheme } from '@mui/material/styles';
import { createOptions as createBaseOptions } from './base/create-options';
import { createOptions as createLightOptions } from './light/create-options';

export const createTheme = () => {
  const theme = createMuiTheme(createBaseOptions(), createLightOptions());

  return theme;
};
